/*
 * fn: fetchTypeahead
 *
 * Fetches a given static endpoint used by typeahead components
 *
 */
import { type TypeaheadOptionType, type TypeaheadStaticModeType } from '@/defs/input'
import { fetchApi } from '@/utils/requestUtil'

type SetsResponseType = {
  code: string
  name: string
}

const CONFIG = {
  set: async () =>
    (await fetchApi<SetsResponseType[]>({ base: 'jsonCloudflare', path: '/static/typeahead/sets' })).data.map<
      TypeaheadOptionType<string>
    >((r) => ({
      label: r.name,
      value: r.code,
    })),
}

export const fetchTypeahead = async (mode: TypeaheadStaticModeType): Promise<TypeaheadOptionType<string>[]> =>
  await CONFIG[mode]()
